const initialState = {
    bookingType: 'laneBooking',
    bookingLocation: 'UK',
    bookingCart: [],
};

export default initialState;
